var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cc-titled-panel",
    { attrs: { title: _vm.talent.Name, icon: "cci-trait" } },
    [
      _c(
        "v-btn",
        {
          attrs: { slot: "items", icon: "" },
          on: {
            click: function($event) {
              return _vm.$refs.dialog.show()
            }
          },
          slot: "items"
        },
        [
          _c("v-icon", { attrs: { large: "" } }, [
            _vm._v("mdi-information-outline")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "cc-solo-dialog",
        {
          ref: "dialog",
          attrs: {
            large: "",
            icon: "cci-trait",
            "no-confirm": "",
            title: _vm.talent.Name
          }
        },
        [_c("cc-talent-info", { attrs: { talent: _vm.talent } })],
        1
      ),
      _vm._v(" "),
      _c(
        "v-stepper",
        {
          staticClass: "elevation-0 mt-n1 transparent",
          attrs: { "non-linear": "" },
          model: {
            value: _vm.step,
            callback: function($$v) {
              _vm.step = $$v
            },
            expression: "step"
          }
        },
        [
          _c(
            "v-stepper-header",
            {
              staticClass: "elevation-0",
              staticStyle: { height: "50px!important" }
            },
            _vm._l(3, function(i) {
              return _c(
                "v-stepper-step",
                {
                  key: i,
                  staticClass: "pa-0",
                  attrs: {
                    step: "I".repeat(i),
                    complete: _vm.pilotRank >= i,
                    "complete-icon": "cci-rank-" + i,
                    "edit-icon": "cci-rank-" + i,
                    editable: ""
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.talent.Rank(i).Name) + "\n      "
                  )
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-stepper-items",
            _vm._l(3, function(i) {
              return _c(
                "v-stepper-content",
                {
                  key: i,
                  staticClass: "pt-0 pb-2",
                  attrs: { step: "I".repeat(i) }
                },
                [
                  _c("cc-talent-rank-item", {
                    attrs: {
                      lock: _vm.pilotRank < i,
                      rank: i,
                      "talent-rank": _vm.talent.Rank(i)
                    }
                  }),
                  _vm._v(" "),
                  _vm.pilotRank < i
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            disabled:
                              !_vm.available ||
                              (_vm.newPilot && i > 1) ||
                              _vm.pilotRank + 1 < i,
                            outlined: "",
                            color: "secondary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.add()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("cci-accuracy")
                          ]),
                          _vm._v(
                            "\n          Unlock " +
                              _vm._s(_vm.talent.Name) +
                              ": " +
                              _vm._s(_vm.talent.Rank(i).Name) +
                              "\n        "
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-btn",
                        {
                          attrs: { block: "", outlined: "", color: "error" },
                          on: {
                            click: function($event) {
                              return _vm.remove()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("cci-difficulty")
                          ]),
                          _vm._v(
                            "\n          Unlearn " +
                              _vm._s(_vm.talent.Name) +
                              ": " +
                              _vm._s(_vm.talent.Rank(i).Name) +
                              "\n        "
                          )
                        ],
                        1
                      )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }